import { render, staticRenderFns } from "./Payrun.vue?vue&type=template&id=1c45c1b2"
import script from "./Payrun.vue?vue&type=script&lang=js"
export * from "./Payrun.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports